// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__11a8E","title":"styles_title__UiRaS"};